import { SectionItem } from '@/features/jobs/info-gathering/components/Section'

export interface ContactInfoSectionItemsProps {
  phoneNumber?: string
  email?: string
}

export function ContactInfoSectionItems({
  phoneNumber,
  email,
}: ContactInfoSectionItemsProps) {
  return (
    <>
      <SectionItem label="Phone number" value={phoneNumber} isSensitive />
      <SectionItem label="Email address" value={email} isSensitive />
    </>
  )
}
